import { INotificationsState } from "@edp-store/state/notifications.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const notificationsSelector = (state: IAppState) => state.notifications;

export const getOptOutState = createSelector(notificationsSelector, (state: INotificationsState) => state.optOut);
export const getDevice = createSelector(notificationsSelector, (state: INotificationsState) => state.device);
export const getPushConfigs = createSelector(notificationsSelector, (state: INotificationsState) => state.pushConfigs);
